import { fetchWrapper } from '../Helpers';

const baseUrl = `${process.env.REACT_APP_API_URL}` + "/influencerlist";
const baseUrlListUrl = `${process.env.REACT_APP_API_URL}` + "/ds-inf-lists";
export const influencerlistService = {

  getAll,
  getById,
  create,
  updateListName,
  deleteList,
  getAllInfluencer,
  removeFromList,
  assignToList,
  createListandAddInfluencer,
  getInfluencerForList,
  getSocialMedia,
  getAllList,
  getAllInfluencerOfList,
  assignInfToList,
  fetchProducts,
  fetchCount,
  getElgibleInfluencer,
  addMoreInfluencer,
  getSortedInfluencerList
};

function getAllList(options) {
  let filterString = '';
  if (options && options.filter) {
    filterString = options.filter;
  }
  if (options && options.page !== undefined) {
    filterString = getAllPagingForList(options, filterString);
  }
  const url =
    filterString.length > 0 ? `${baseUrlListUrl}?${filterString}` : `${baseUrlListUrl}`;
  return fetchWrapper.get(url);
}
function getAllInfluencerOfList(id, options) {
  let filterString = '';
  if (options.filter) {
    filterString = options.filter;
  }
  if (options.page !== undefined) {
    filterString = getAllPagingForList(options, filterString);
  }
  const url =
    filterString.length > 0 ? `${baseUrlListUrl}/${id}?${filterString}` : `${baseUrlListUrl}/${id}`;
  //console.log(url);

  return fetchWrapper.get(url);
  //return fetchWrapper.get(`${baseUrl}/getAllInf/${id}`);
}

function getAllPagingForList(options, filterString) {
  //console.log(options)
  filterString += filterString.length > 0 ? `&` : '';
  filterString += `page=${options.page}`;
  if (options.pageSize) {
    filterString += filterString.length > 0 ? `&` : '';
    filterString += `perPage=${options.pageSize}`;
  }
  return filterString;
}
function assignInfToList(id, params) {
  //console.log(params)
  return fetchWrapper.post(baseUrlListUrl + "/" + id + "/add-influencer", params);
}

function getAll(options) {
  let filterString = '';
  if (options.filter) {
    filterString = options.filter;
  }
  if (options.page !== undefined) {
    filterString = getAllPaging(options, filterString);
  }
  const url =
    filterString.length > 0 ? `${baseUrl}?${filterString}` : `${baseUrl}`;
  return fetchWrapper.get(url);
}

function getAllPaging(options, filterString) {
  //console.log(options)
  filterString += filterString.length > 0 ? `&` : '';
  filterString += `page[number]=${options.page}`;
  if (options.pageSize) {
    filterString += filterString.length > 0 ? `&` : '';
    filterString += `page[size]=${options.pageSize}`;
  }
  return filterString;
}
function getById(id) {
  return fetchWrapper.get(`${baseUrl}/getById/${id}`);
}
function getSocialMedia() {
  return fetchWrapper.get(`${baseUrl}/getSocialMedia/`);
}

function getInfluencerForList(id) {
  //console.log("=====to get " + id)
  return fetchWrapper.get(`${baseUrl}/getAllInf/${id}`);
}

function getAllInfluencer(id, options) {
  let filterString = '';
  if (options.filter) {
    filterString = options.filter;
  }
  if (options.page !== undefined) {
    filterString = getAllPaging(options, filterString);
  }
  const url =
    filterString.length > 0 ? `${baseUrl}/getAllInf/${id}?${filterString}` : `${baseUrl}/getAllInf/${id}`;
  //console.log(url);

  return fetchWrapper.get(url);
  //return fetchWrapper.get(`${baseUrl}/getAllInf/${id}`);
}

function createListandAddInfluencer(params) {
  return fetchWrapper.post(baseUrlListUrl + "/with-influencers", params);
}

function create(params) {
  //console.log(params)
  return fetchWrapper.post(baseUrlListUrl, params);
}

function updateListName(id, params) {
  return fetchWrapper.post(`${baseUrlListUrl}/${id}`, params);
}

// prefixed with underscore because 'delete' is a reserved word in javascript
function deleteList(id) {
  //console.log(id)
  return fetchWrapper.delete(`${baseUrlListUrl}/${id}`);
}
function removeFromList(id, params) {

  //console.log(params)
  return fetchWrapper.post(baseUrlListUrl + "/" + id + "/remove-influencer", params);
}
function assignToList(params) {
  //console.log(params)
  return fetchWrapper.post(baseUrl + "/status", params);
}

function fetchProducts() {
  //console.log(params)
  return fetchWrapper.get(`${process.env.REACT_APP_API_URL}/nproducts`);
}

function fetchCount(id) {
  //console.log(params)
  return fetchWrapper.get(`${baseUrlListUrl}/${id}/product-influencer-counts`);
}

function getElgibleInfluencer(listId, productId) {
  return fetchWrapper.get(`${baseUrlListUrl}/${listId}/products/${productId}/users`);

}
function addMoreInfluencer(id,params) {
  return fetchWrapper.post(`${baseUrlListUrl}/${id}/add-influencer-by-handle`, params);
}
function getSortedInfluencerList(list_id, params) {
  const queryString = params.sort ? `?sort=${params.sort}` : '';
  return fetchWrapper.get(`${baseUrlListUrl}/${list_id}${queryString}`);
}


